<template>
  <div class="orgBox">
    <div class="organ">
      <!-- <div class="orgTopbg">
        <img class="orgbg" src="../../assets/images/pageHome/topTitle.png" alt />
        <div class="orgTop">社会组织</div>
        <div class="back" @click="back">
          <img src="../../assets/images/back.png" alt />
          <span>返回</span>
        </div>
      </div> -->
      <div class="top">
        <div class="tit">社会组织</div>
        <div class="border"></div>
        <div class="back" @click="back">
          <img src="../../assets/images/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="orgCenter">
        <div class="orgLeft">
          <div class="orgTab">
            <img
              class="orgImgs"
              @click="changeNames()"
              src="../../assets/images/orgTab.png"
              alt
            />
            <div class="orgBox">
              <div
                :class="[item.flage ? 'active' : 'orgList']"
                v-for="(item, index) in orgList"
                :key="index"
                @click="changeName(item)"
              >
                {{ item.addressName }}
              </div>
            </div>
          </div>
        </div>
        <div class="orgRight">
          <div class="orgTitle">
            <div class="orgInput">
              <img
                class="searchs"
                @click="search()"
                src="../../assets/images/search.png"
                alt
              />
              <div class="orgText">社会组织列表</div>
              <div class="block"></div>
              <input
                class="rgba(80, 39, 7, 1)"
                v-model="input"
                @input="getinput($event)"
                placeholder="请输入"
              />
              <img
                class="shap"
                src="../../assets/images/shap.png"
                @click="search()"
                alt
              />
            </div>
            <div class="orgSearch">
              <div class="orgStop">
                <img
                  class="typeImg"
                  style="margin-left: 10px"
                  src="../../assets/images/type.png"
                  alt
                />
                <div class="typeText" style="height: 40px; line-height: 40px">
                  类型
                </div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="ltype" name="fruit" @change="changeKey($event)">
                    <option value>请选择</option>
                    <option
                      v-for="(item,index) in keyList"
                      :key="index"
                      :value="item.dictId"
                    >{{item.dictName}}</option>
                  </select>
                </div> -->
                <div class="select" style="width: 118px">
                  <el-select
                    style="width: 118px"
                    v-model="ltype"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeKey()"
                  >
                    <el-option
                      v-for="item in keyList"
                      :key="item.dictId"
                      :label="item.dictName"
                      :value="item.dictId"
                    >
                    </el-option>
                  </el-select>
                  <img
                    src="../../assets/images/orgup.png"
                    @click="changeKey()"
                    alt=""
                  />
                </div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="ltypes" style="width:166px" name="fruit" @change="changeKeys($event)">
                    <option value>请选择</option>
                    <option
                      v-for="(item,index) in keyLists"
                      :key="index"
                      :value="item.dictId"
                    >{{item.dictName}}</option>
                  </select>
                </div> -->
                <div class="select" style="width: 176px">
                  <el-select
                    style="width: 176px"
                    v-model="ltypes"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeKeys($event)"
                  >
                    <el-option
                      v-for="item in keyLists"
                      :key="item.dictId"
                      :label="item.dictName"
                      :value="item.dictId"
                    >
                    </el-option>
                  </el-select>
                  <img
                    @click="changeKeys()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
                <img
                  class="typeImg"
                  style="height: auto; padding-top: 20px"
                  src="../../assets/images/hType.png"
                  alt
                />
                <div class="typeText">服务类别</div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="ltypez" name="fruit" @change="changeFtype($event)">
                    <option value>请选择</option>
                    <option
                      v-for="(item,index) in fLists"
                      :key="index"
                      :value="item.dictId"
                    >{{item.dictName}}</option>
                  </select>
                </div> -->
                <div class="select" style="width: 160px">
                  <el-select
                    style="width: 160px"
                    v-model="ltypez"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeFtype()"
                  >
                    <el-option
                      v-for="item in fLists"
                      :key="item.dictId"
                      :label="item.dictName"
                      :value="item.dictId"
                    >
                    </el-option>
                  </el-select>
                  <img
                    @change="changeFtype()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="ftype" style="width:188px" name="fruit" @change="changeFtypes($event)">
                    <option value>请选择</option>
                    <option
                      v-for="(item,index) in fListz"
                      :key="index"
                      :value="item.dictId"
                    >{{item.dictName}}</option>
                  </select>
                </div> -->
                <div class="select" style="width: 201px">
                  <el-select
                    style="width: 201px"
                    v-model="ftype"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeFtypes()"
                  >
                    <el-option
                      v-for="item in fListz"
                      :key="item.dictId"
                      :label="item.dictName"
                      :value="item.dictId"
                    >
                    </el-option>
                  </el-select>
                  <img
                    @change="changeFtypes()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
                <img
                  class="typeImg"
                  style="height: auto; padding-top: 20px"
                  src="../../assets/images/oType.png"
                  alt
                />
                <div class="typeText">是否有党组织</div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="typeD" name="fruit" @change="changeD($event)">
                    <option value>请选择</option>
                    <option value="1">是</option>
                    <option value="0">否</option>
                  </select>
                </div> -->
                <div class="select" style="width: 112px">
                  <el-select
                    style="width: 112px"
                    v-model="typeD"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeD()"
                  >
                    <!-- <el-option
                v-for="item in fLists"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
              </el-option> -->
                    <el-option label="是" key="1" value="1"> </el-option>
                    <el-option label="否" key="0" value="0"> </el-option>
                  </el-select>
                  <img
                    src="../../assets/images/orgup.png"
                    @change="changeD()"
                    alt=""
                  />
                </div>
                <img
                  class="typeImg"
                  style="height: auto; padding-top: 16px"
                  src="../../assets/images/cType.png"
                  alt
                />
                <div class="typeText">是否慈善组织</div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="typeO" name="fruit" @change="changeO($event)">
                    <option value>请选择</option>
                    <option value="1">是</option>
                    <option value="0">否</option>
                  </select>
                </div> -->
                <div class="select" style="width: 112px">
                  <el-select
                    style="width: 112px"
                    v-model="typeO"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeO()"
                  >
                    <!-- <el-option
                v-for="item in fLists"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
              </el-option> -->
                    <el-option label="是" key="1" value="1"> </el-option>
                    <el-option label="否" key="0" value="0"> </el-option>
                  </el-select>
                  <img
                    @change="changeO()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="orgSboot">
                <img
                  class="typeImg"
                  style="height: auto; padding-top: 16px; margin-left: 10px"
                  src="../../assets/images/orgIcon.png"
                  alt
                />
                <div class="typeText">社会组织等级</div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="typeA" name="fruit" @change="changeA($event)">
                    <option value>请选择</option>
                    <option value="5A">5A</option>
                    <option value="4A">4A</option>
                    <option value="3A">3A</option>
                    <option value="其他">其他</option>
                  </select>
                </div> -->
                <div class="select" style="width: 112px">
                  <el-select
                    style="width: 112px"
                    v-model="typeA"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    @change="changeA()"
                  >
                    <!-- <el-option
                v-for="item in fLists"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
              </el-option> -->
                    <el-option label="5A" key="1" value="1"> </el-option>
                    <el-option label="4A" key="2" value="2"> </el-option>
                    <el-option label="3A" key="3" value="3"> </el-option>
                    <el-option label="其他" key="4" value="4"> </el-option>
                  </el-select>
                  <img
                    @change="changeA()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
                <img
                  class="typeImg"
                  style="height: auto; padding-top: 16px"
                  src="../../assets/images/year.png"
                  alt
                />
                <div class="typeText">是否年检</div>
                <!-- <div class="selectBox">
                  <img class="selectImg" src="../../assets/images/orgup.png" alt />
                  <select v-model="typeC" name="fruit" @change="changeC($event)">
                    <option value>请选择</option>
                    <option value="2">是</option>
                    <option value="1">否</option>
                  </select>
                </div> -->
                <div class="select" style="width: 112px">
                  <el-select
                    style="width: 112px"
                    v-model="typeC"
                    placeholder="请选择"
                    placeholder-style="color:rgba(255, 255, 255, 0.5)"
                    :popper-append-to-body="false"
                    @change="changeC()"
                  >
                    <!-- <el-option
                v-for="item in fLists"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
              </el-option> -->
                    <el-option label="是" key="1" value="1"> </el-option>
                    <el-option label="否" key="2" value="2"> </el-option>
                  </el-select>
                  <img
                    @change="changeC()"
                    src="../../assets/images/orgup.png"
                    alt=""
                  />
                </div>
                <div class="set" @click="clear">清空</div>
                <div class="orgSearchs" @click="search">搜索</div>
              </div>
            </div>
          </div>
          <div class="orgRightop" style="padding: 0 11px">
            <div
              class="orgConter"
              v-for="(item, index) in list"
              :key="index"
              @click="toDetail(item)"
            >
              <div class="orgConLeft">
                <img
                  style="margin: 0px 30px 0px 0px; height: 40px"
                  v-if="item.party"
                  src="../../assets/images/danghui.png"
                  alt
                />
                <div>
                  {{ item.orgName }}
                </div>
              </div>
              <div class="orgConRight">
                <img
                  class="orgAddress"
                  v-if="item.address"
                  src="../../assets/images/orgAddress.png"
                  alt
                />
                <div
                  class="orgNewtxt"
                  style="padding-bootom: 3px; margin-right: 20px"
                >
                  {{ item.address }}
                </div>
              </div>
            </div>

            <div
              v-if="total == 0"
              style="
                color: #ffe1ce;
                font-size: 30px;
                font-weight: 600;
                margin-top: 200px;
                text-align: center;
              "
            >
              暂无相关数据
            </div>
          </div>
        </div>
        <Pagination
          v-if="total > 0"
          style="margin-bottom: 23px"
          :total="total"
          :page="page"
          :size="5"
          @pagination="fetchData"
        />
      </div>
    </div>
    <div class="orgbg"></div>
  </div>
</template>
<script>
import baseUrl from "../../config/config";
import axios from "axios";
import Pagination from "@/components/pagination";
export default {
  name: "",
  components: {
    Pagination,
  },

  data() {
    return {
      typeA: "",
      typeC: "",
      typeZ: "",
      serviceType: "",
      orgBigType: "",
      changeId: "",
      parentId: "",
      page: 1,
      typeD: "",
      typeO: "",
      charitable: "", //是否慈善组织
      party: "", //是否党组织
      dictId: "",
      ltype: "", //类型
      keyLists: "",
      ltypes: "",
      keyList: "",
      ltypez: "",
      keyListz: "",
      fLists: "",
      fListz: "",
      ftype: "",
      list: [],
      baseUrl: baseUrl,
      total: 0,
      currentPage: 0,
      annualInspection: "",
      orgLevel: "",
      orgLevelFlag: null,
      // total:10,
      searchForm: {
        pageSize: 1,
      },
      listLoading: false,
      type: "",
      input: "",
      value: "",
      orgList: [],
      orgName: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
    };
  },
  created() {
    this.orgList.map((v) => {
      v.flage = false;
    });
    this.getTab();
    this.getqueryDictByKey("teamwordBigType");
    this.getqueryDictByKeyz("serviceType");
    // this.ltypes = 0
    var q = this.$route.query.id;
    console.log(q);
    // if(this.$route.query.typeName){
    //   this.typeA = this.$route.query.typeName
    //   this.orgLevelFlag = this.$route.query.typeName
    //    if (this.orgLevelFlag == 1) {
    //     this.orgLevel = '5A'
    //   } else if (this.orgLevelFlag == 2) {
    //     this.orgLevel = '4A'
    //   } else if (this.orgLevelFlag == 3) {
    //     this.orgLevel = '3A'
    //   } else if (this.orgLevelFlag == 4) {
    //     this.orgLevel = '其他'
    //   }
    // }
    if (this.$route.query.typeId) {
      this.ltype = Number(this.$route.query.typeId);
      this.changeId = Number(this.$route.query.typeId);
    }
    if (this.$route.query.dictParentKey) {
      this.ltypez = Number(this.$route.query.dictParentKey);
      this.parentId = Number(this.$route.query.dictParentKey);
      console.log(this.$route.query.dictParentKey);
      this.getqueryDictByKeyz("serviceType");
      if (this.$route.query.dictId) {
        this.ftype = Number(this.$route.query.dictId);
        this.serviceCategory = Number(this.$route.query.dictId);
        this.getqueryDictByKeyzi("projectCategory");
      }
      this.parentId = null;
      this.changeId = null;
      this.getList();
    } else {
      // this.getList()
    }
    if (this.$route.query.isParties) {
      this.typeD = this.$route.query.isParties;
      this.party = this.$route.query.isParties;
      console.log(Number(this.$route.query.isParties), "typeDtypeDtypeD");
      this.getList();
    } else {
      // this.getList()
    }
    if (this.$route.query.typeName) {
      this.typeA = this.$route.query.typeName;
      // let orgLevel = this.$route.query.typeName
      this.orgLevelFlag = this.$route.query.typeName;
      if (this.orgLevelFlag == 1) {
        this.orgLevel = "5A";
      } else if (this.orgLevelFlag == 2) {
        this.orgLevel = "4A";
      } else if (this.orgLevelFlag == 3) {
        this.orgLevel = "3A";
      } else if (this.orgLevelFlag == 4) {
        this.orgLevel = "其他";
      }
      console.log(this.$route.query.typeName);
      this.getList();
    } else {
      // this.getList()
    }
    if (this.$route.query.typeId) {
      this.ltype = Number(this.$route.query.typeId);
      this.changeId = Number(this.$route.query.typeId);
      // this.parentId = Number(this.$route.query.typeId)
      console.log(this.orgBigType, "orgBigTypeorgBigTypeorgBigTypeorgBigType");
      this.getqueryDictByKeys("teamwordType");
      this.ltypes = Number(this.$route.query.id);
      this.orgType = Number(this.$route.query.id);
      this.getList();
    } else {
      this.getList();
    }
  },

  methods: {
    toDetail(item) {
      let id = item.id;
      this.$router.push({ path: "/socialorgDetails", query: { id } });
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    //清空
    clear() {
      (this.orgName = ""),
        (this.orgType = ""),
        (this.serviceCategory = ""),
        (this.party = ""),
        (this.charitable = ""),
        //  this.street="",
        (this.ltype = ""),
        (this.ltypes = ""),
        (this.ltypez = ""),
        (this.ftype = ""),
        (this.typeD = ""),
        (this.typeO = ""),
        (this.changeId = ""),
        (this.parentId = ""),
        (this.typeA = ""),
        (this.typeC = ""),
        (this.orgLevel = ""),
        (this.annualInspection = "");
      (this.input = ""),
        (this.orgName = ""),
        (this.keyLists = []),
        (this.fListz = []);
      this.getList();
    },
    //社会组织等级
    changeA() {
      if (this.typeA == 1) {
        this.orgLevel = "5A";
      } else if (this.typeA == 2) {
        this.orgLevel = "4A";
      } else if (this.typeA == 3) {
        this.orgLevel = "3A";
      } else if (this.typeA == 4) {
        this.orgLevel = "其他";
      }
    },
    //是否年检
    changeC() {
      this.annualInspection = this.typeC;
    },
    //是否有党组织
    changeD() {
      this.party = this.typeD;
    },
    //是否慈善组织
    changeO() {
      this.charitable = this.typeO;
    },
    //类型选择
    changeKey() {
      // console.log(item.target.value,'item')
      this.changeId = this.ltype;
      this.getqueryDictByKeys("teamwordType");
    },
    //子类型选择
    changeKeys() {
      this.orgType = this.ltypes;
      // console.log($event.target.value,'items')
    },
    //服务类型
    changeFtype() {
      this.parentId = this.ltypez;
      this.getqueryDictByKeyzi("projectCategory");
    },
    //子服务类型
    changeFtypes() {
      this.serviceCategory = this.ftype;
      // console.log($event.target.value,'items')
    },
    getinput(e) {
      this.orgName = e.target.value;
      console.log(this.input);
    },
    search() {
      this.orgName = this.input;
      this.page = 1;
      this.getList();
    },
    //子服务类型下拉框
    getqueryDictByKeyzi(me) {
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl + "/system/dictController/queryDictByKeyParent",
          {
            key: me,
            parentId: this.parentId,
          }
        )
        .then(function (response) {
          console.log(response, "类型");
          that.fListz = response.data;
          // that.ltypez = that.fLists[0].dictId
          this.ltypes = Number(this.$route.query.id);
          this.orgType = Number(this.$route.query.id);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //服务类型下拉框
    getqueryDictByKeyz(me) {
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl + "/system/dictController/queryDictByKeyParent",
          {
            key: me,
          }
        )
        .then(function (response) {
          console.log(response, "类型");
          that.fLists = response.data;
          // that.fLists.map((v)=>{
          //   if(v.dictId==that.dictParentKey){
          //      that.ltypez = v.dictName
          //      console.log(that.ltypez,'that.ltypez=====')
          //   }
          // })
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //类型下拉框
    getqueryDictByKey(me) {
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl + "/system/dictController/queryDictByKeyParent",
          {
            key: me,
          }
        )
        .then(function (response) {
          console.log(response, "类型");
          that.keyList = response.data;
          // that.ltype = that.keyList[0].dictId
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //子类型下拉框
    getqueryDictByKeys(me) {
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl + "/system/dictController/queryDictByKeyParent",
          {
            key: me,
            parentId: this.changeId,
          }
        )
        .then(function (response) {
          console.log(response, "类型");
          that.keyLists = response.data;
          // that.ltypes = that.keyLists[0].dictName
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //左侧列表
    getTab() {
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl +
            "/system/sysAddressController/selecteAddressByCityTeamWork",
          {
            parentId: 330102,
          }
        )
        .then(function (response) {
          console.log(response, "左侧列表");
          that.orgList = response.data;
          that.orgList.map((v) => {
            v.flage = false;
          });
          console.log(that.orgList, "that.orgList");
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //列表
    getList() {
      console.log(baseUrl, "baseUrl");
      this.listLoading = true;
      let that = this;
      axios
        .post(
          this.baseUrl.baseUrl +
            "/system/wechat/kyyOrganizationPcController/selectKyyOrgList",
          {
            page: this.page,
            orgName: this.orgName,
            orgType: this.orgType,
            orgBigType: this.changeId,
            serviceType: this.parentId,
            serviceCategory: this.serviceCategory,
            party: this.party,
            charitable: this.charitable,
            street: this.street,
            orgLevel: this.orgLevel,
            annualInspection: this.annualInspection,
            limit: 5,
          }
        )
        .then(function (response) {
          console.log(response, "列表");
          that.list = response.data.list;
          that.total = response.data.total;
          console.log(response.data.total, "list");
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fetchData(e) {
      console.log(e);
      this.page = e;
      this.getList();
    },
    handleCurrentChange(cpage) {
      this.currentPage = cpage || 9;
    },
    jumpFirstPage() {
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit("handleCurrentChange", 1);
    },
    jumpLastPage() {
      let font = this.$refs.pagination;
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    changeName(item) {
      console.log(item, "item");

      this.orgList.map((v) => {
        console.log(v.flage, "v.flage");
        v.flage = false;
        if (item.addressName == v.addressName) {
          v.flage = true;
        }
      });
      this.street = item.id;
      this.list = [];
      this.getList();
    },
    changeNames() {
      this.orgList.map((v) => {
        console.log(v.flage, "v.flage");
        v.flage = false;
      });
      this.street = "";
      this.list = [];
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.orgbg {
  // position: absolute;
  // top: -100px;
  // left: -100px;
  // width: 1790px;
  // height: 900px;
  // width: 1765px;
  // height: 810px;
  // background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
  // position: absolute;
  // right: 16px;
  // bottom: 6px;
  // pointer-events: none;
  width: 1630px;
  height: 680px;
  background: url("../../assets/images/nrq.png") no-repeat center / 100% 100%;
  position: absolute;
  right: 48px;
  bottom: 34px;
  pointer-events: none;
}
.select {
  width: 190px;
  height: 40px;
  position: relative;
  margin: 0 0 0 10px;
  /deep/ .el-input__inner {
    // background: rgba(113, 54, 8, 0.8);
    background: #07111e;

    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    border: none;
    .el-input {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  /deep/ .el-select-dropdown {
    background: #251403;
    font-size: 22px;
    font-weight: 400;
    color: #ffffff;
    left: 0 !important;
    margin-top: 0px !important;
    border: 0;
    border-radius: 0;
    .el-select-dropdown__item {
      font-size: 22px;
      font-weight: 400;
      color: #ffffff;
    }
    .el-select-dropdown__item.hover {
      // background: #8b4208;
      background: #07111e;
    }
  }
  /deep/ .el-popper .popper__arrow {
    display: none;
  }
  /deep/ .el-input__suffix {
    display: none;
  }
  select {
    width: 190px;
    height: 40px;
    background: rgba(113, 54, 8, 0.8);
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    padding-left: 10px;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    option {
      background: #251403;
      font-size: 22px;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  img {
    position: absolute;
    right: 10px;
    top: 15px;
    width: 11px;
    height: 7px;
    pointer-events: none;
  }
}
.back {
  position: absolute;
  top: 30px;
  right: 43px;
  font-size: 24px;
  font-weight: 400;
  color: #1080d0;
  cursor: pointer;
  img {
    width: 20px;
    height: 21px;
    margin-right: 9px;
  }
}
.orgBox {
  background: #000;
}
.orgRightop {
  height: 648px;
  width: 1630px;
  //  background: url("../../assets/images/conterBg.png") no-repeat center/100% 100%;
  // background-color: rgba(192, 103, 25, 0.17);
  padding-top: 18px !important;
}
.shap {
  width: 18px;
  height: 18px;
  position: absolute;
  right: 20px;
  top: 16px;
}
.orgSboot {
  padding-left: 8px;
  display: flex;
  align-items: center;
  height: 88px;
}
select {
  // min-width: 118px;
  border: solid 0px #000;
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  outline: none;
  // background: url("../../assets/images/orgup.png") no-repeat scroll right center /
  //   15% 21%;
  // /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  padding: 0 10px;
  margin: 0 10px;
  // width: 118px;
  height: 40px;
  background-color: rgba(113, 54, 8, 0.8);
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  // opacity: 0.9;
  color: rgba(255, 255, 255, 0.5);
  padding-right: 24px;
}
option {
  background: #251403;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
}
.selectBox {
  position: relative;
}
.selectImg {
  width: 11px;
  height: 7px;
  position: absolute;
  right: 21px;
  top: 17px;
  z-index: 999;
}
select::-ms-expand {
  display: none;
}
input {
  background: none;
  outline: none;
  border: 0px;
  color: #ffffff;
  font-size: 24px;
}
input::-webkit-input-placeholder {
  line-height: 24px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.3;
}
.organ {
  height: 1080px;
  // background: url("../../assets/images/neirong.png") no-repeat center/100% 100%;
  position: relative;
}
.orgTab {
  width: 199px;
  height: 100%;
  img {
    padding: 0;
    margin: 0;
  }
  .orgImgs {
    width: 199px;
    height: 90px;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
  .orgBox {
    width: 197px;
    padding-bottom: 1px;
    height: 817px;
    padding: 18px 0;
    margin-top: -5px;
    background: url("../../assets/images/orgTaber.png") no-repeat center/100%
      100%;
  }
  .orgList:first-child {
    margin-top: 0;
    // padding-top: 16px;
  }
  .active:first-child {
    margin-top: 0;
    // padding-top: 16px;
  }
  .orgList {
    font-size: 23px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 23px;
    margin: 33px 0;
    text-align: center;
    opacity: 0.6;
    cursor: pointer;
  }
  .active {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 24px;
    margin: 35px 0;
    text-align: center;
    opacity: 1;
    cursor: pointer;
  }
}
.orgConter {
  padding: 0 30px;
  background: url("../../assets/images/listbg.png") no-repeat center/97% 100%;
  height: 99px;
  // width: 98%;
  margin-left: -22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
  cursor: pointer;
  .orgConLeft {
    margin-left:30px ;
    display: flex;
    align-items: center;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 99px;
  }
  .orgConRight {
    display: flex;
    flex-direction: row;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.4;
    line-height: 99px;
    .orgAddress {
      width: 23px;
      height: 30px;
      margin-right: 10px;
      margin-top: 35px;
    }
  }
}
.top {
  height: 92px;
  overflow: hidden;
  position: relative;
  background: url("../../assets/images/pageHome/topTitle.png") no-repeat
    center/100% 100%;
  .tit {
    // display: flex;
    // height: 33px;
    width: 300px;
    // line-height: 33px;
    margin-top: 23px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    // background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    margin-left: 886px;
  }
  .back {
    position: absolute;
    top: 31px;
    right: 43px;
    font-size: 24px;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
    img {
      width: 20px;
      height: 21px;
      margin-right: 9px;
    }
  }
}
// .orgTopbg {
//   height: 80px;
//   // background-image: url("../../assets/images/pageHome/topTitle.png") no-repeat center/100% 100%;
//   .orgbg {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 80px;
//   }

//   .orgTop {
//     font-size: 32px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: #ffffff;
//     opacity: 0.91;
//     height: 80px;
//     line-height: 80px;
//     background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-image: url("../../assets/images/pageHome/topTitle.png") no-repeat
//       center/100% 100%;
//     text-align: center;
//   }
// }
.orgInput {
  width: 1000px;
  height: 50px;
  background: #07111e;
  // opacity: 0.8;
  border-radius: 5px;
  display: flex;
  align-content: center;
  // margin-top: 13px;
  margin-left: 5px;
  position: relative;
  .searchs {
    width: 24px;
    height: 24px;
    margin: 14px;
  }
  .orgText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.9;
    margin: 13px 0;
  }
  .block {
    margin: 0 20px;
    margin-top: 8px;
    height: 34px;
    border: 2px solid #064085;
  }
  .oInput {
    height: 24px;
    margin-top: 13px;
    font-size: 22px;
    color: #ffffff;
  }
}
.set {
  margin-left: 30px;
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  // background: url("../../assets/images/set.png") no-repeat center/100% 100%;
  background: linear-gradient(90deg, #064085, #0e69e4);
  cursor: pointer;
  border-radius: 6px;
}
.orgSearchs {
  margin-left: 5px;
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  // background: url("../../assets/images/orgSearch.png") no-repeat center/100%
  // 100%;
  background: linear-gradient(90deg, #064085, #0e69e4);
  cursor: pointer;
  border-radius: 6px;
}
.orgStop {
  display: flex;
  align-items: center;
  height: 88px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding-left: 8px;
}
.orgSearch {
  // display: flex;
  // align-items: center;
  height: 57%;
  .typeImg {
    width: 20px;
    height: 27px;
    padding-top: 5px;
    margin: 0 9px 0 40px;
  }
  .typeText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.9;
  }
}
.orgCenter {
  display: flex;
  flex-direction: row;
}
.orgItext {
  display: flex;
  flex-direction: row;
  .oText {
    width: 24%;
  }
}
.orgLeft {
  margin-left: 30px;
  margin-top: 6px;
  width: 10%;
  height: 75.6%;
  /deep/.el-aside {
    background-color: transparent !important;
  }
}
/deep/.el-menu {
  background-color: transparent !important;
}
.el-menu {
  width: 200px;
  height: 909px;
  background: url("../../assets/images/orgLeft.png") no-repeat center/100% 100%;

  .el-submenu {
    /deep/ .el-submenu__title {
      width: 198px;
      height: 90px;
      background: url("../../assets/images/orgLeft1.png") no-repeat center/100%
        100%;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      padding: 0;
      text-align: center;
      line-height: 90px;
      opacity: 0.5;
    }
    /deep/ .el-submenu__title:hover {
      opacity: 1;
    }
    /deep/ .el-menu-item-group__title:hover {
      background: url("../../assets/images/orgLeft2.png") no-repeat center/100%;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 57px;
      line-height: 57px;
      text-align: center;
    }
    /deep/.el-menu-item-group__title {
      height: 57px;
      line-height: 57px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 0 !important;
      text-align: center;
    }
    /deep/.el-menu-item-group__title:hover {
      opacity: 1;
    }
  }
}
.orgRight {
  // background: url("../../assets/images/orgCenter.png") no-repeat center/100%;
  width: 1630px;
  height: 909px;
  position: relative;
  overflow: hidden;
  margin-left: 20px;
  .orgTitle {
    background: url("../../assets/images/orgTitle.png") no-repeat center/100%;
    width: 100%;
    height: 240px;
    padding-top: 13px;
    margin-bottom: 20px;
    // background: #08223e;
    border-radius: 10px;
  }
  // .orgList {
  //     margin-left: 20PX;
  //     margin-bottom: 25PX;
  //   background: url("../../assets/images/govList.png") no-repeat center/100%;
  //   width: 1594px;
  //   height: 184px;
  //   .orgRight{
  //     display: flex;
  //     flex-direction: row;
  //   }
  //   .orgLtitle {
  //     height: 34px;
  //     font-size: 36px;
  //     font-family: Source Han Sans CN;
  //     font-weight: 400;
  //     color: #ffffff;
  //     height: 113px;
  //     line-height: 113px;
  //     padding-left: 32PX;
  //   }
  //   .orgMess {
  //     display: flex;
  //     flex-direction: row;
  //     padding-left: 32PX;
  //     height: 71PX;
  //     img {
  //       width: 29px;
  //       height: 29px;
  //       margin-right: 5PX;
  //       margin-top: 2PX;
  //     }
  //     .per {
  //       font-size: 28px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 400;
  //       color: #ffffff;
  //       opacity: 0.4;
  //       height: 34PX;
  //       line-height: 28PX;
  //       margin-top: 16PX;
  //       padding-right: 20PX;
  //       margin-right: 20PX;
  //       // border-right: 1PX solid #ffffff;
  //     }
  //   }
  // }
}
option:active,
option:hover {
  outline: none;
}
option:active,
option:hover {
  background: rgba(80, 39, 7, 0.8);
}
</style>
